import { LEGAL_URLS } from "../config";

export function Disclaimer() {
  return (
    <footer className="disclaimer">
      <p>
        PriceTilt is a research tool, not financial or legal advice. Always
        verify property data and consult a licensed real-estate professional
        before making an offer.
      </p>
      <p className="disclaimer-legal">
        <a href={LEGAL_URLS.privacy} target="_blank" rel="noreferrer noopener">Privacy</a>
        <span aria-hidden> · </span>
        <a href={LEGAL_URLS.terms} target="_blank" rel="noreferrer noopener">Terms</a>
        <span aria-hidden> · </span>
        <a href={LEGAL_URLS.security} target="_blank" rel="noreferrer noopener">
          Security &amp; trust
        </a>
      </p>
    </footer>
  );
}
